import { Component } from '@angular/core';
import { CurrentUser } from '@shared/interfaces';
import { ToasterPositionEnum } from '@shared/enums';
import { CurrentUserService } from '@core/services';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent {
    isLoading: boolean = true;
    hasError: boolean = false;
    currentUser: CurrentUser | null = null;
    toasterPositions = ToasterPositionEnum;

    isUnauthorized: boolean = false;

    constructor(private currentUserService: CurrentUserService) {
        this.currentUserService.currentUser$.subscribe(user => {
            this.currentUser = user;
            this.isLoading = false;
        });

        this.currentUserService.isUnauthorized$.subscribe(value => {
            this.isUnauthorized = value;
            this.currentUser = null;
            this.isLoading = false;
        });
    }
}
